module.exports = __webpack_public_path__ + "img/avatar_6.eefea188.svg";